var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3738",
    "data-name": "Group 3738",
    transform: "translate(-146.5 -282)",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-star",
    "data-name": "Icon awesome-star",
    d: "M12.6.869,9.549,7.333,2.722,8.373a1.582,1.582,0,0,0-.827,2.666l4.939,5.029-1.168,7.1a1.509,1.509,0,0,0,2.168,1.645l6.107-3.354,6.107,3.354a1.51,1.51,0,0,0,2.168-1.645l-1.168-7.1,4.939-5.029a1.582,1.582,0,0,0-.827-2.666l-6.827-1.04L15.282.869A1.469,1.469,0,0,0,12.6.869Z",
    transform: "translate(145.059 282.001)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingNone);
export default __webpack_public_path__ + "static/media/ratingNone.a2a4957efd6456b412529f63105c3d23.svg";
export { ForwardRef as ReactComponent };